export const ROUTES = {
  HOME: '/',
  EXHIBITORS: '/exhibitors',
  EXHIBITOR_DETAIL: '/exhibitors/:id',
  PARTNERS: '/partners',
  PARTNER_DETAIL: '/partners/:id',
  PAVILIONS: '/pavilions',
  METRICS: '/metrics',
  NETWORKING: '/networking',
  EVENTS: '/events',
  LOGIN: '/login',
  DEMO_ACCOUNTS: '/demo',
  FORGOT_PASSWORD: '/forgot-password',
  REGISTER: '/register',
  REGISTER_VISITOR: '/register/visitor',
  REGISTER_EXHIBITOR: '/register/exhibitor',
  REGISTER_PARTNER: '/register/partner',
  SIGNUP_SUCCESS: '/signup-success',
  SIGNUP_CONFIRMATION: '/signup-confirmation',
  PENDING_ACCOUNT: '/pending-account',
  OAUTH_CALLBACK: '/auth/callback',
  PROFILE: '/profile',
  PROFILE_DETAILED: '/profile/detailed',
  PROFILE_MATCHING: '/profile/matching',
  DASHBOARD: '/dashboard',
  EXHIBITOR_PROFILE: '/exhibitor/profile',
  EXHIBITOR_DASHBOARD: '/exhibitor/dashboard',
  PARTNER_DASHBOARD: '/partner/dashboard',
  PARTNER_PROFILE: '/partner/profile',
  PARTNER_SETTINGS: '/partner/settings',
  VISITOR_DASHBOARD: '/visitor/dashboard',
  VISITOR_SETTINGS: '/visitor/settings',
  MESSAGES: '/messages',
  CHAT: '/chat',
  APPOINTMENTS: '/appointments',
  CALENDAR: '/calendar',
  MINISITE: '/minisite',
  MINISITE_DIRECTORY: '/minisites',
  MINISITE_CREATION: '/minisite-creation',
  RESET_PASSWORD: '/reset-password',
  MINISITE_EDITOR: '/minisite/editor',
  ADMIN_CREATE_EXHIBITOR: '/admin/create-exhibitor',
  ADMIN_EXHIBITORS: '/admin/exhibitors',
  ADMIN_CREATE_PARTNER: '/admin/create-partner',
  ADMIN_PARTNERS_MANAGE: '/admin/partners-manage',
  ADMIN_CREATE_EVENT: '/admin/create-event',
  ADMIN_EVENTS: '/admin/events',
  ADMIN_VIP_VISITORS: '/admin/vip-visitors',
  ADMIN_CREATE_NEWS: '/admin/create-news',
  ADMIN_NEWS: '/admin/news',
  MINISITE_PREVIEW: '/minisite/:exhibitorId',
  ADMIN_ACTIVITY: '/admin/activity',
  ADMIN_VALIDATION: '/admin/validation',
  ADMIN_MODERATION: '/admin/moderation',
  NEWS: '/news',
  NEWS_DETAIL: '/news/:id',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_USERS: '/admin/users',
  ADMIN_CREATE_USER: '/admin/users/create',
  ADMIN_PAVILIONS: '/admin/pavilions',
  ADMIN_CREATE_PAVILION: '/admin/create-pavilion',
  ADMIN_PAVILION_ADD_DEMO: '/admin/pavilion/:pavilionId/add-demo',
  ADMIN_CONTENT: '/admin/content',
  ADMIN_EMAIL_TEMPLATES: '/admin/email-templates',
  CONTACT: '/contact',
  CONTACT_SUCCESS: '/contact/success',
  PARTNERSHIP: '/partnership',
  SUPPORT: '/support',
  API: '/api',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  COOKIES: '/cookies',
  AVAILABILITY_SETTINGS: '/availability/settings',
  VENUE: '/venue',

  // Pages partenaires
  PARTNER_ACTIVITY: '/partner/activity',
  PARTNER_ANALYTICS: '/partner/analytics',
  PARTNER_EVENTS: '/partner/events',
  PARTNER_LEADS: '/partner/leads',
  PARTNER_MEDIA: '/partner/media',
  PARTNER_NETWORKING: '/partner/networking',
  PARTNER_PROFILE_EDIT: '/partner/profile/edit',
  PARTNER_SATISFACTION: '/partner/satisfaction',
  PARTNER_SUPPORT_PAGE: '/partner/support-page',

  // Pages admin manquantes
  ADMIN_PARTNERS: '/admin/partners',
  ADMIN_MEDIA: '/admin/media',
  ADMIN_EXHIBITORS_LIST: '/admin/exhibitors-list',
  ADMIN_USERS_LIST: '/admin/users-list',
  ADMIN_PUBLICATION_CONTROL: '/admin/publication-control',

  // Pages erreur
  UNAUTHORIZED: '/unauthorized',
  FORBIDDEN: '/forbidden',
  NOT_FOUND: '/404',

  // Pages inscription/subscription
  EXHIBITOR_SUBSCRIPTION: '/exhibitor/subscription',
  PARTNER_SUBSCRIPTION: '/partner/subscription',

  // Pages visiteur
  VISITOR_SUBSCRIPTION: '/visitor/subscription',
  VISITOR_UPGRADE: '/visitor/upgrade',
  VISITOR_PAYMENT: '/visitor/payment',
  VISITOR_BANK_TRANSFER: '/visitor/bank-transfer',
  VISITOR_PAYMENT_SUCCESS: '/visitor/payment-success',
  VISITOR_PAYMENT_INSTRUCTIONS: '/visitor/payment-instructions',
  VISITOR_FREE_REGISTRATION: '/visitor/register/free',
  VISITOR_VIP_REGISTRATION: '/visitor/register/vip',
  BADGE: '/badge',

  // Mini-Site Builder
  CREATE_MINI_SITE: '/exhibitor/mini-site/create',
  EDIT_MINI_SITE: '/exhibitor/mini-site/:siteId/edit',
  MINI_SITE_VIEW: '/mini-sites/:siteId',

  // Networking & Matchmaking
  NETWORKING_MATCHMAKING: '/networking/matchmaking',
  NETWORKING_ROOMS: '/networking/rooms/:eventId',
  SPEED_NETWORKING: '/networking/speed/:sessionId',
  INTERACTION_HISTORY: '/networking/history',
  BADGE_DIGITAL: '/badge/digital',
  BADGE_SCANNER: '/badge/scanner',
  BADGE_PRINT_STATION: '/badge/print-station',
  SECURITY_SCANNER: '/security/scanner',

  // Partner upgrade routes
  PARTNER_UPGRADE: '/partner/upgrade',
  PARTNER_PAYMENT_SELECTION: '/partner/payment-selection',
  PARTNER_BANK_TRANSFER: '/partner/bank-transfer',

  // Admin payment
  ADMIN_PAYMENT_VALIDATION: '/admin/payment-validation',

  // Marketing Dashboard
  MARKETING_DASHBOARD: '/marketing/dashboard',

  // Media Routes - Nouvelles fonctionnalités
  MEDIA_LIBRARY: '/media',
  MEDIA_DETAIL: '/media/:id',
  WEBINARS: '/media/webinars',
  WEBINAR_DETAIL: '/media/webinar/:id',
  PODCASTS: '/media/podcasts',
  PODCAST_DETAIL: '/media/podcast/:id',
  CAPSULES_INSIDE: '/media/inside-siport',
  CAPSULE_DETAIL: '/media/capsule/:id',
  LIVE_STUDIO: '/media/live-studio',
  LIVE_STUDIO_DETAIL: '/media/live-studio/:id',
  BEST_MOMENTS: '/media/best-moments',
  BEST_MOMENTS_DETAIL: '/media/best-moments/:id',
  TESTIMONIALS: '/media/testimonials',
  TESTIMONIAL_DETAIL: '/media/testimonial/:id',
  
  // Admin Media Management
  ADMIN_MEDIA_CREATE: '/admin/media/create',
  ADMIN_MEDIA_MANAGE: '/admin/media/manage',
  ADMIN_MEDIA_EDIT: '/admin/media/edit/:id',
  ADMIN_LIVE_EVENTS: '/admin/live-events',
  ADMIN_LIVE_EVENT_CREATE: '/admin/live-events/create',
  ADMIN_PARTNER_MEDIA_APPROVAL: '/admin/partner-media/approval',

  // Partner Media Management
  PARTNER_MEDIA_UPLOAD: '/partner/media/upload',
  PARTNER_MEDIA_ANALYTICS: '/partner/media/analytics',
  PARTNER_MEDIA_LIBRARY: '/partner/media/library',

  // Autres
  PRODUCT_DETAIL: '/products/:id',
  EXHIBITOR_PROFILE_EDIT: '/exhibitor/profile/edit',
  DEV_TEST_FLOW: '/dev/test-flow',
} as const;

export type RouteKey = keyof typeof ROUTES;
